import React, { useState } from 'react';
import logo_tucky_computer from '../../Images/Logo/logo_tucky_computer.png';
import DataServiceSQL from '../../DataService/DataServiceSQL.js';

const DisclaimerModal = ({ username, onAccepted }) => {
    const [loading, setLoading] = useState(false);

    const handleAccept = async () => {
        setLoading(true);
        try {
            await DataServiceSQL.acceptDisclaimerReq_fhir(username);
        } catch (e) {
            console.error(e);
        }
        setLoading(false);
        onAccepted();
    };

    return (
        <div style={styles.overlay}>
            <div style={styles.modal}>
                <div style={styles.header}>
                    <img src={logo_tucky_computer} alt="Tucky Center" style={styles.logo} />
                    <div style={styles.badge}>Information importante</div>
                </div>

                <div style={styles.body}>
                    <div style={styles.iconWrapper}>
                        <span style={styles.icon}>ℹ</span>
                    </div>
                    <h2 style={styles.title}>Avis d&apos;utilisation</h2>
                        <p style={styles.message}>
                            <strong>Tucky Center</strong> est un dispositif médical numérique de télésurveillance.
                        </p>

                        <p style={styles.sub}>
                            Il fournit aux professionnels de santé des informations cliniques non urgentes à partir
                            des données transmises par des appareils de mesure connectés.
                        </p>

                        <p style={styles.sub}>
                            La télésurveillance ne constitue pas une prise en charge d&apos;urgence : les données
                            enregistrées et les alertes ne sont pas lues ni interprétées instantanément, mais uniquement
                            pendant les jours et horaires définis par l&apos;opérateur de télésurveillance.
                        </p>

                        <p style={styles.sub}>
                            En cas d&apos;urgence médicale, contactez immédiatement les services d&apos;urgence
                            <strong> 15 / 112</strong>. Les données affichées ne remplacent en aucun cas l&apos;avis
                            d&apos;un professionnel de santé.
                        </p>
                </div>

                <div style={styles.footer}>
                    <button
                        onClick={handleAccept}
                        disabled={loading}
                        style={loading ? { ...styles.button, ...styles.buttonDisabled } : styles.button}
                    >
                        {loading ? (
                            <span>Chargement&hellip;</span>
                        ) : (
                            <span>J&apos;ai bien pris connaissance de cette information.</span>
                        )}
                    </button>
                </div>
            </div>
        </div>
    );
};

const styles = {
    overlay: {
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        backgroundColor: 'rgba(10, 25, 47, 0.80)',
        backdropFilter: 'blur(4px)',
        zIndex: 9999,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '16px',
    },
    modal: {
        backgroundColor: '#ffffff',
        borderRadius: '16px',
        boxShadow: '0 25px 60px rgba(0,0,0,0.35)',
        maxWidth: '480px',
        width: '100%',
        overflow: 'hidden',
        animation: 'fadeInUp 0.3s ease',
    },
    header: {
        background: 'linear-gradient(135deg, #1a3a5c 0%, #2d6a9f 100%)',
        padding: '28px 32px 20px',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: '12px',
    },
    logo: {
        height: '48px',
        width: 'auto',
        filter: 'brightness(0) invert(1)',
    },
    badge: {
        backgroundColor: 'rgba(255,255,255,0.18)',
        color: '#ffffff',
        fontSize: '0.72rem',
        fontWeight: '600',
        letterSpacing: '0.08em',
        textTransform: 'uppercase',
        padding: '4px 12px',
        borderRadius: '20px',
        border: '1px solid rgba(255,255,255,0.35)',
    },
    body: {
        padding: '32px 32px 20px',
        textAlign: 'center',
    },
    iconWrapper: {
        display: 'flex',
        justifyContent: 'center',
        marginBottom: '16px',
    },
    icon: {
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: '52px',
        height: '52px',
        borderRadius: '50%',
        backgroundColor: '#e8f4fd',
        color: '#2d6a9f',
        fontSize: '1.6rem',
        fontWeight: 'bold',
        border: '2px solid #b8d9f2',
    },
    title: {
        fontSize: '1.25rem',
        fontWeight: '700',
        color: '#1a2e45',
        marginBottom: '16px',
        letterSpacing: '-0.01em',
    },
    message: {
        fontSize: '1.05rem',
        color: '#1a2e45',
        lineHeight: '1.6',
        marginBottom: '16px',
        padding: '16px',
        backgroundColor: '#f0f7ff',
        borderRadius: '10px',
        borderLeft: '4px solid #2d6a9f',
    },
    sub: {
        fontSize: '0.85rem',
        color: '#5a7084',
        lineHeight: '1.55',
        marginBottom: '8px',
    },
    footer: {
        padding: '16px 32px 28px',
        display: 'flex',
        justifyContent: 'center',
    },
    button: {
        background: 'linear-gradient(135deg, #1a3a5c 0%, #2d6a9f 100%)',
        color: '#ffffff',
        border: 'none',
        borderRadius: '10px',
        padding: '14px 40px',
        fontSize: '1rem',
        fontWeight: '600',
        cursor: 'pointer',
        letterSpacing: '0.02em',
        boxShadow: '0 4px 14px rgba(45, 106, 159, 0.45)',
        transition: 'opacity 0.2s',
        minWidth: '220px',
    },
    buttonDisabled: {
        opacity: 0.65,
        cursor: 'not-allowed',
    },
};

export default DisclaimerModal;
